<template>
  <form>
    <div class="phone-input-container">
      <p class="error"
        :class="{ hidden: !error.isShown }">{{ error.text }}</p>
        <vue-tel-input
          v-model="phonenumber"
          class="phone-input"
          ref="phoneInput"
          :placeholder="this.$t('components.phoneinput.enter')"
          :required="true"
          :disabledFetchingCountry="true"
          :defaultCountry="globalCountry"
          :onlyCountries="countries">
        </vue-tel-input>
        <button
          type="submit"
          v-on:click.prevent="submitPhonenumber"
          :disabled="isLoading"
          class="phone-button">
          <span v-if="!isLoading">{{ buttonText ? buttonText : $t('components.phoneinput.call-now') }}</span>
          <span v-if="isLoading" class="loading">{{ $t('loading') }}<span>.</span><span>.</span><span>.</span></span>
          <div v-if="!hideButtonSmall && !isLoading" class="button_text-small">{{ $t('components.phoneinput.free') }}</div>
        </button>
      <p class="privacy-policy">{{ $t('pages.recurring-signup.privacy-policy-text') }} <router-link :to="{ name: 'privacy' }">{{ $t('pages.recurring-signup.privacy-policy') }}</router-link> {{ $t('pages.recurring-signup.privacy-policy-text-between') }} <a href="https://www.twilio.com/legal/privacy">{{ $t('pages.recurring-signup.privacy-policy-twilio') }}</a>.</p>
    </div>
  </form>
</template>

<script>
import CountriesMixin from '@/mixins/CountriesMixin.vue'
import { resolveJSON } from '@/helperfunctions'

export default {
  name: 'PhoneInputContainer',
  mixins: [CountriesMixin],
  props: {
    buttonText: String,
    hideButtonSmall: Boolean,
    onSubmit: String,
  },
  data () {
    return {
      error: {
        isShown: false,
        text: ''
      },
      isLoading: false,
    }
  },
  computed: {
    phonenumber: {
      get: function() {
        return this.$root.phonenumber.formatted
      },
      set: function(phonenumber) {
        this.$root.phonenumber.formatted = phonenumber
      }
    },
    globalCountry() {
      return this.$root.country
    },
    countries () {
      return this.$root.countries.map((c) => c[0])
    },
    isValid () {
      return this.$refs.phoneInput.response.isValid
    },
    anyWeekday () {
      return this.$root.recurringPicker.weekday.Monday ||
        this.$root.recurringPicker.weekday.Tuesday ||
        this.$root.recurringPicker.weekday.Wednesday ||
        this.$root.recurringPicker.weekday.Thursday ||
        this.$root.recurringPicker.weekday.Friday
    },
  },
  methods: {
    submitPhonenumber() {
      if (this.onSubmit === 'recurring-signup') {
        this.submitRecurringSignup()
      } else if (this.onSubmit === 'recurring-settings') {
        this.submitRecurringSignup(true)
      } else {
        this.submitInstantCall()
      }
    },
    submitInstantCall() {
      this.error.text = ''
      this.error.isShown = false

      if (!this.isValid) {
        this.error.text = this.$t('components.phoneinput.error-invalid')
        this.error.isShown = true
        return false;
      }

      this.$root.loadingAnimation = true
      this.isLoading = true

      fetch('/api/v/1/call/', {
        method: 'POST',
        body: JSON.stringify({
          mep_id: this.$root.mep.id,
          phonenumber: this.$root.phonenumber.digit,
          lang: this.$route.params.lang
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resolveJSON)
        .then(json => {
          if (!json.success) {
            if (!json.error) {
              throw Error(this.$t('components.phoneinput.error-nondescript'))
            }
            throw Error(json.error)
          }

          this.$root.callInitiated = true
          this.$root.loadingAnimation = false
          this.isLoading = false
          this.$router.push({ name: 'thanks' })
        })
        .catch(error => {
          this.$root.phonenumber.formatted = null
          this.$root.phonenumber.digit = null
          this.error.text = error.message
          this.error.isShown = true
          this.$root.loadingAnimation = false
          this.isLoading = false
        })
    },
    submitRecurringSignup(settings) {
      this.error.text = ''
      this.error.isShown = false

      if(!this.anyWeekday && !settings) {
        this.error.text = this.$t('pages.recurring-signup.error-weekday')
        this.error.isShown = true
        return
      }

      if (!this.$root.phonenumber.digit) {
        this.error.text = this.$t('pages.recurring-signup.error-phonenumber')
        this.error.isShown = true
        return
      }

      this.isLoading = true

      fetch('/api/user', {
        method: 'POST',
        body: JSON.stringify({
          country: this.$root.country,
          language: this.$route.params.lang,
          phone_number: this.$root.phonenumber.digit,
          monday: this.$root.recurringPicker.weekday.Monday,
          tuesday: this.$root.recurringPicker.weekday.Tuesday,
          wednesday: this.$root.recurringPicker.weekday.Wednesday,
          thursday: this.$root.recurringPicker.weekday.Thursday,
          friday: this.$root.recurringPicker.weekday.Friday,
          time: this.$root.recurringPicker.time
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resolveJSON)
        .then(json => {
          if (!json.success) {
            if (!json.error) {
              throw Error(this.$t('components.phoneinput.error-nondescript'))
            }
            throw Error(json.error)
          }
          this.$router.push({ name: 'recurring-signup-confirmation' })
          this.isLoading = false
        })
        .catch(error => {
          this.error.text = error.message
          this.error.isShown = true
          this.isLoading = false
        })
    }

  },
}
</script>

<style lang=scss>
@import '@/assets/styles/_variable.scss';

.phone-input-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  .phone-input {
    font-size: 0.8em;
    line-height: 1em;
    flex: 1 0 50%;
    width: 100%;
    border: 3px solid #b9b9b9 !important;
    border-radius: 0  !important;
    box-shadow: none !important;
    background: #fff;
    .dropdown {
      align-self: center;
      &:hover {
        background-color: inherit;
      }
    }
    &:focus-within {
      border-color: black;
      box-shadow: none !important;
    }

    input[type="tel"] {
      background-color: transparent;
      min-height: 2em;
      font-size: 1.6em;
      @media (max-width: 520px) {
        font-size: 1.2em;
      }
      font-family: $font-family-primary;
      letter-spacing: .1em;
      max-width: calc(100% - 56px);
      &:placeholder-shown {
        letter-spacing:0;
      }
    }
  }
  .privacy-policy {
    font-size: .8em;
    margin: .5em 0 0;
    color: #000;
    line-height: 1.3em;
  }
  .phone-button {
    @media (max-width: 419px) {
      font-size: 1.4em;
    }
  }
}
</style>
